import { CustomTimer } from '@tunein/web-utils';
import { noop } from 'es-toolkit';
import { api, player } from '../../../singletons';
const play = {
    category: 'play',
    actions: {
        start: 'start',
        successMs: 'successMs',
        totalSuccessMs: 'totalSuccessMs',
        failMs: 'failMs',
        totalFailMs: 'totalFailMs',
    },
    labels: {
        preroll: 'preroll',
        noroll: 'noroll',
        auto: 'auto',
        manual: 'manual',
        next: 'next',
        qualified: 'qualified',
    },
};
export class TunePathMetricsReporter {
    #sessionData;
    #sessionStartTime;
    #streamLoadStartTime;
    #didReportSuccess = false;
    #qualifiedTuneTimer = null;
    #log(event) {
        const { guideItem: { guideId: id, itemToken }, listenId, } = this.#sessionData;
        const params = { id, itemToken, listenId };
        api.telemetry.reportEvent({ event, params }).catch(noop);
    }
    #logSuccessOrFail() {
        const { category, actions, labels } = play;
        const label = `${player.getEngineName()}.${player.didPlayPreroll ? labels.preroll : labels.noroll}`;
        this.#log({
            category,
            action: this.#didReportSuccess ? actions.successMs : actions.failMs,
            label,
            value: (Date.now() - this.#streamLoadStartTime).toString(),
        });
        this.#log({
            category,
            action: this.#didReportSuccess
                ? actions.totalSuccessMs
                : actions.totalFailMs,
            label,
            value: (Date.now() - this.#sessionStartTime).toString(),
        });
    }
    #onQualifiedTune = () => {
        this.#log({
            category: play.category,
            action: play.actions.start,
            label: play.labels.qualified,
        });
    };
    #reportSuccess() {
        this.#didReportSuccess = true;
        this.#logSuccessOrFail();
        this.#qualifiedTuneTimer = new CustomTimer(this.#onQualifiedTune, 60_000);
        this.#qualifiedTuneTimer.start();
    }
    get isTimerPaused() {
        return this.#qualifiedTuneTimer?.isPaused;
    }
    /**
     * Represents the start of a listening session, when load() is called
     */
    startSession(sessionData) {
        this.#didReportSuccess = false;
        this.#sessionData = sessionData;
        this.#sessionStartTime = Date.now();
        this.#log({
            category: play.category,
            action: play.actions.start,
            label: sessionData.isAutoPlayingNextStream
                ? play.labels.next
                : sessionData.isUserInitiated
                    ? play.labels.manual
                    : play.labels.auto,
        });
    }
    /**
     * Represents the start of the stream loading sequence, after stream data has been fetched and prerolls have finished
     * playing
     */
    onStartStreamLoad() {
        this.#streamLoadStartTime = Date.now();
    }
    onPlaying() {
        if (!this.#didReportSuccess) {
            this.#reportSuccess();
        }
        if (this.isTimerPaused) {
            this.resumeTimer();
        }
    }
    pauseTimer() {
        this.#qualifiedTuneTimer?.pause();
    }
    resumeTimer() {
        this.#qualifiedTuneTimer?.start();
    }
    clearTimer() {
        this.#qualifiedTuneTimer?.clear();
    }
    reportFailure() {
        if (!this.#didReportSuccess) {
            this.#logSuccessOrFail();
        }
    }
}
